module.exports = __webpack_public_path__ + "img/aaaa1_sample.9241a3a1.png";